import React, { useState } from 'react';
import NewProvider from './components/NewProvider';
import EditProvider from './components/EditProvider';
import { Col, Container, Row } from 'react-bootstrap';
import ProvidersList from './components/ProvidersList';

const Providers = () => {
  const [listRequiresReload, setListRequiresReload] = useState(true);
  const [selectedProvider, setSelectedProvider] = useState();

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Providers Management</h3>
          <h3 className="page-subhead subhead">Manage workspace providers</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <ProvidersList setSelectedProvider={setSelectedProvider} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload} />
        </Col>
        <Col md={4}>
          {!selectedProvider && <NewProvider setSelectedProvider={setSelectedProvider} setListRequiresReload={setListRequiresReload} selectedProvider={selectedProvider} />}
          {selectedProvider && <EditProvider setSelectedProvider={setSelectedProvider} setListRequiresReload={setListRequiresReload} selectedProvider={selectedProvider} />}
        </Col>
      </Row>
    </Container>
  );
};

export default Providers;